import { Query } from "@syncfusion/ej2-data";
import { DatePickerComponent } from "@syncfusion/ej2-react-calendars";
import { DropDownListComponent } from "@syncfusion/ej2-react-dropdowns";
import {
  ColumnDirective,
  ColumnsDirective,
  ExcelExport,
  GridComponent,
  Inject,
  Page,
  Resize,
  Search,
  Sort,
  Toolbar,
} from "@syncfusion/ej2-react-grids";
import axios from "axios";
import { getCookie } from "cookies-next";
import React, { useEffect, useRef, useState } from "react";
import {
  FaDownload,
  FaEye,
  FaPlus,
  FaRegEye,
  FaRegEyeSlash,
  FaRegistered,
  FaRightToBracket,
  FaShareFromSquare,
  FaXmark,
} from "react-icons/fa6";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

import { FaEdit } from "react-icons/fa";
import { Header, PageLoading } from "../../../components";
import { API_ROOT } from "../../../config";
import { useStateContext } from "../../../contexts/ContextProvider";
import "../../table.css";

const InputPassword = ({ value, disabled, onChange }) => {
  const type = "password";
  const [typeIn, setTypeIn] = useState(type);

  return (
    <div className="flex flex-col">
      <div className="relative flex flex-col">
        <input
          type={typeIn}
          placeholder="Input password..."
          className="w-full p-2 text-sm rounded-[4px] border border-slate-500 focus:outline-2 focus:outline-sky-500"
          value={value}
          disabled={disabled}
          onChange={onChange}
        />
        {type === "password" && typeIn === "password" && (
          <button
            type="button"
            tabIndex={-1}
            className="bg-white h-[calc(100%-4px)] px-2 text-gray-500 absolute top-1/2 transform -translate-y-1/2 right-2"
            onClick={() => setTypeIn("text")}
          >
            <FaRegEye className="w-5 h-5" />
          </button>
        )}
        {type === "password" && typeIn === "text" && (
          <button
            type="button"
            tabIndex={-1}
            className="bg-white h-[calc(100%-4px)] px-2 text-gray-500 absolute top-1/2 transform -translate-y-1/2 right-2"
            onClick={() => setTypeIn("password")}
          >
            <FaRegEyeSlash className="w-5 h-5" />
          </button>
        )}
      </div>
    </div>
  );
};

const UserList = () => {
  const navigate = useNavigate();
  const { currentColor } = useStateContext();

  const [pageLoading, setPageLoading] = useState(true);
  const [userList, setUserList] = useState([]);
  const [refresh, setRefresh] = useState(0);
  const [toggleAdd, setToggleAdd] = useState(false);
  const [toggleEdit, setToggleEdit] = useState(false);
  const [toggleDetail, setToggleDetail] = useState(false);
  const [isDetailMode, setIsDetailMode] = useState(false);
  const [roleSelected, setRoleSelected] = useState("");

  const PERSONEL = "PERSONAL";
  const COMPANY = "COMPANY";

  // Master data
  const [countries, setCountries] = useState([]);
  const [roles, setRoles] = useState([]);
  const [cities, setCities] = useState([]);
  const [provinces, setProvinces] = useState([]);

  const [editUserData, setEditUserData] = useState({
    // Add Company
    username: null,
    password: null,

    uuid: null,
    // Users table
    country_id: null,
    name: null,
    birthdate: null,
    email: null,
    email_verified: null, // TAMBAHAN BARU
    phone_number: null,
    nik: null,
    no_npwp: null,
    sign_name: null,
    role_id: null,

    // Company Data
    nama_pj: null,
    email_pj: null,

    // User detail table
    place_of_birth: null,
    gender: null,
    address: null,
    city_id: null,
    is_wna: null,
    is_markany_user: false,
    ktp_foto: null,

    // User markany table
    markany_username: null,
    markany_password: null,
    markany_user_id: null,
    markany_role_id: null,
    status: null,
    org_unit: null,
    work_unit: null,
    position: null,
    token: null,
    refresh_token: null,
    exp_token: null,
  });

  const [editUserWarning, setEditUserWarning] = useState({
    username: null,
    password: null,
    country_id: null,
    name: null,
    birthdate: null,
    role_id: null,
    place_of_birth: null,
    gender: null,
    email: null,
    email_verified: null, // TAMBAHAN BARU
    nama_pj: null, // company
    email_pj: null, // company
    phone_number: null,
    nik: null,
    no_npwp: null,
    address: null,
    city_id: null,
    is_wna: null,
    username: null,
    sign_name: null,
    markany_username: null,
    markany_password: null,
  });

  const [editUserDisabled, setEditUserDisabled] = useState(false);
  const [editLoading, setEditLoading] = useState(false);
  const gridRef = useRef(null);

  // Dropdown data
  const genderOptions = [
    { text: "Male", value: "male" },
    { text: "Female", value: "female" },
  ];

  const isWnaOptions = [
    { text: "Yes", value: true },
    { text: "No", value: false },
  ];

  const emailVerifiedOptions = [
    { text: "Yes", value: true },
    { text: "No", value: false },
  ];

  const formatDate = (inputDate) => {
    const months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    const days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
    const date = new Date(inputDate);
    const dayOfWeek = days[date.getUTCDay()];
    const day = date.getUTCDate();
    const month = months[date.getUTCMonth()];
    const year = date.getUTCFullYear();
    const hours = date.getUTCHours();
    const minutes = date.getUTCMinutes();
    const seconds = date.getUTCSeconds();

    return `${dayOfWeek}, ${day} ${month} ${year} ${hours
      .toString()
      .padStart(2, "0")}:${minutes.toString().padStart(2, "0")}:${seconds
      .toString()
      .padStart(2, "0")}`;
  };

  const dateInputFormat = (inputDate) => {
    const date = new Date(inputDate);
    const day = date.getUTCDate();
    const month = date.getUTCMonth() + 1;
    const year = date.getUTCFullYear();

    return `${year}-${month.toString().padStart(2, "0")}-${day
      .toString()
      .padStart(2, "0")}`;
  };

  function onCityFiltering(args) {
    let query = new Query();
    query =
      args.text !== ""
        ? query.where("text", "contains", args.text, true)
        : query;
    args.updateData(cities, query);
  }

  const fetchMasterData = async () => {
    try {
      // Fetch countries
      const countriesResponse = await axios.get(
        API_ROOT + "/admin/masterdata/countries",
        {
          headers: { Authorization: getCookie("admin_auth") },
        },
      );
      setCountries(
        countriesResponse.data.data.map((item) => ({
          text: item.name,
          value: item.id,
        })),
      );

      const citiesResponse = await axios.get(
        API_ROOT + "/admin/masterdata/cities",
        {
          headers: { Authorization: getCookie("admin_auth") },
        },
      );
      setCities(
        citiesResponse.data.data.map((item) => ({
          text: item.name_city,
          value: item.id,
          province_id: item.province_id,
        })),
      );

      // Fetch roles
      const rolesResponse = await axios.get(
        API_ROOT + "/admin/masterdata/roles",
        {
          headers: { Authorization: getCookie("admin_auth") },
        },
      );
      setRoles(
        rolesResponse.data.data.map((item) => ({
          key: item.key_role,
          text: item.nama_role,
          value: item.id,
        })),
      );
    } catch (error) {
      console.log("Failed to fetch master data:", error);
    }
  };

  const fetchData = async () => {
    await axios
      .get(API_ROOT + "/admin/user/list?offset=1&limit=all", {
        headers: {
          Authorization: getCookie("admin_auth"),
        },
      })
      .then((response) => {
        const data = response.data.data;
        setUserList(() =>
          data.map((item, index) => ({
            No: index + 1,
            Uuid: item.uuid,
            Role: item.role?.key_role,
            IsRegisterMarkany: item.is_register_markany,
            IsSubmittedEkycMarkany: item.is_submitted_ekyc_markany,
            Name: item.name,
            Username: item.username,
            Balance: item?.users_balance?.balance,
            Email: item.email,
            EmailVerified: item.email_verified,
            PhoneNumber: item.phone_number,
            PhoneNumberVerified: item.phone_number_verified,
            ekyc: item.user_detail?.ekyc,
            CreatedAt: formatDate(item.created_at),
          })),
        );
        setPageLoading(false);
      })
      .catch((error) => {
        if (error.response) {
          if (error.response.status == 401) {
            navigate("/login");
            return;
          }
        }
        console.log(error);
        toast.error("Failed to get data");
      });
  };

  const fetchUserDetail = async (uuid, keyRole) => {
    try {
      const response = await axios.get(
        API_ROOT + "/admin/user/detail/" + uuid,
        {
          headers: { Authorization: getCookie("admin_auth") },
        },
      );

      const userData = response.data.data;
      setEditUserData({
        uuid: userData.uuid,
        // Users table
        country_id: userData.country_id,
        name: userData.name,
        birthdate: userData.birthdate ? new Date(userData.birthdate) : null,
        email: userData.email,
        email_verified: userData.email_verified,
        phone_number: userData.phone_number,
        nik: userData.nik,
        sign_name: userData.sign_name,
        role_id: userData.role_id,

        // Company Data
        nama_pj: userData.nama_pj,
        email_pj: userData.email_pj,

        // User detail table
        no_npwp: userData.user_detail?.no_npwp,
        place_of_birth: userData.user_detail?.place_of_birth,
        gender: userData.user_detail?.gender,
        address: userData.user_detail?.address,
        city_id: userData.user_detail?.city_id,
        is_wna: userData.user_detail?.is_wna,
        ktp_foto: userData.user_detail?.ktp_foto,
        ekyc: userData.user_detail?.ekyc,
        ttd_signature: userData.user_detail?.ttd_signature,
        ttd_paraf: userData.user_detail?.ttd_paraf,
        is_markany_user: userData.user_detail?.is_markany,

        // User markany table
        markany_username: userData.user_markany?.username,
        markany_password: userData.user_markany?.password,
        markany_email: userData.user_markany?.email,
        markany_user_id: userData.user_markany?.markany_user_id,
        markany_role_id: userData.user_markany?.role_id,
        status: userData.user_markany?.status,
        org_unit: userData.user_markany?.org_unit,
        work_unit: userData.user_markany?.work_unit,
        position: userData.user_markany?.position,
        token: userData.user_markany?.token,
        refresh_token: userData.user_markany?.refresh_token,
        exp_token: userData.user_markany?.exp_token,
      });

      setRoleSelected(keyRole || "");
    } catch (error) {
      toast.error("Failed to fetch user details");
      console.log(error);
    }
  };

  const fetchMarkanySignIn = async (uuid, email, password) => {
    await axios
      .post(
        API_ROOT + "/admin/user/markany/signin/" + uuid,
        {
          email,
          password,
        },
        {
          headers: { Authorization: getCookie("admin_auth") },
        },
      )
      .then((response) => {
        const data = response.data.data;
        console.log(data);
        if (Object.keys(data).length) {
          setEditUserData((prev) => ({
            ...prev,
            // User markany table
            markany_user_id: data.markany_user_id,
            role_id: data.role_id,
            status: data.status,
            org_unit: data.org_unit,
            work_unit: data.work_unit,
            position: data.position,
            token: data.token,
            refresh_token: data.refresh_token,
            exp_token: data.exp_token,
          }));
        }
        toast.success(response.data?.message);
      })
      .catch((error) => {
        toast.error("Failed to fetch user details");
        console.log(error);
      });
  };

  useEffect(() => {
    setPageLoading(true);
    setUserList([]);
    setToggleEdit(false);
    setToggleDetail(false);
    setEditLoading(false);
    setEditUserDisabled(false);
    fetchData();
    fetchMasterData();
  }, [refresh]);

  useEffect(() => {
    if (!isDetailMode) {
      for (const value of Object.values(editUserWarning)) {
        if (value !== null) {
          setEditUserDisabled(true);
          return;
        }
      }
      setEditUserDisabled(false);
    }
  }, [editUserWarning, isDetailMode]);

  const actionTemplate = (props) => {
    return (
      <div className="flex justify-start gap-2">
        <button className="e-action" onClick={() => handleDetailUser(props)}>
          <FaEye className="e-actionIcon" />
          <div>Detail</div>
        </button>
        <button
          className="flex items-center gap-2 py-2 px-3 border border-[#3b82f6] rounded-md text-[#3b82f6]"
          onClick={() => handleEditUser(props)}
        >
          <FaEdit className="text-lg" />
          <div>Edit</div>
        </button>
      </div>
    );
  };

  const handleDetailUser = async (userData) => {
    setIsDetailMode(true);
    await fetchUserDetail(userData.Uuid, userData.Role);
    setToggleDetail(true);
  };

  const handleAddUser = async () => {
    resetForm();
    setRoleSelected("COMPANY");
    setIsDetailMode(false);
    setToggleAdd(true);
  };

  const handleEditUser = async (userData) => {
    setIsDetailMode(false);
    await fetchUserDetail(userData.Uuid, userData.Role);
    setToggleEdit(true);
  };

  const handleMarkanySignIn = async (userData) => {
    setEditLoading(true);
    await fetchMarkanySignIn(
      userData.uuid,
      userData.markany_email,
      userData.markany_password,
    );
    setEditLoading(false);
  };

  const handleSubmit = async (selectedRole, isEdit = false) => {
    setEditLoading(true);

    // Validation
    if (isEdit && !editUserData.role_id) {
      setEditUserWarning((prev) => ({
        ...prev,
        role_id: "Role can't be empty",
      }));
      setEditLoading(false);
      return;
    }

    if (!editUserData.name) {
      setEditUserWarning((prev) => ({
        ...prev,
        name: "Name can't be empty",
      }));
      setEditLoading(false);
      return;
    }

    if (!editUserData.email) {
      setEditUserWarning((prev) => ({
        ...prev,
        email: "Email can't be empty",
      }));
      setEditLoading(false);
      return;
    }

    if (roleSelected == COMPANY && !editUserData.email_pj) {
      setEditUserWarning((prev) => ({
        ...prev,
        email_pj: "Email Penanggung Jawab can't be empty",
      }));
      setEditLoading(false);
      return;
    }

    if (roleSelected == COMPANY && !editUserData.nama_pj) {
      setEditUserWarning((prev) => ({
        ...prev,
        nama_pj: "Name Penanggung Jawab can't be empty",
      }));
      setEditLoading(false);
      return;
    }

    try {
      const payload = {
        ...(!isEdit
          ? {
              username: editUserData.username,
              password: editUserData.password,
            }
          : {
              role_id: parseInt(editUserData.role_id),
            }),
        // Users table
        country_id: parseInt(editUserData.country_id),
        name: editUserData.name,
        birthdate: dateInputFormat(editUserData.birthdate),
        email: editUserData.email,
        email_verified: editUserData.email_verified, // TAMBAHAN BARU
        phone_number: editUserData.phone_number,
        nik: editUserData.nik,
        no_npwp: editUserData.no_npwp,

        // User detail table
        place_of_birth: editUserData.place_of_birth,
        gender: editUserData.gender,
        address: editUserData.address,
        city_id: editUserData.city_id,
        is_wna: editUserData.is_wna,
        is_markany_user: editUserData.is_markany_user,

        // User markany table
        markany_username: editUserData.markany_username,
        markany_password: editUserData.markany_password,
        markany_email: editUserData.markany_email,
        org_unit: editUserData.org_unit,
        work_unit: editUserData.work_unit,
        position: editUserData.position,

        ...(selectedRole == PERSONEL
          ? {
              ktp_foto: editUserData.ktp_foto,
              sign_name: editUserData.sign_name,
            }
          : {}),

        ...(selectedRole == COMPANY
          ? {
              nama_pj: editUserData.nama_pj,
              email_pj: editUserData.email_pj,
            }
          : {}),
      };

      if (isEdit) {
        await axios.put(
          API_ROOT + "/admin/user/update/" + editUserData.uuid,
          payload,
          {
            headers: {
              Authorization: getCookie("admin_auth"),
            },
          },
        );
        toast.success("User Updated!");
      } else {
        await axios.post(API_ROOT + "/admin/user/create/company", payload, {
          headers: {
            Authorization: getCookie("admin_auth"),
          },
        });
        toast.success("User Created!");
      }

      setToggleAdd(false);
      setToggleEdit(false);
      setRefresh((prev) => prev + 1);
    } catch (error) {
      toast.error(error.response?.data?.message ?? "Failed to update user!");

      if (error.response) {
        if (error.response.status === 401) {
          navigate("/login");
        }
      }
    }

    setEditLoading(false);
  };

  const getImageMeta = (base64) => {
    if (!base64) return { mime: "image/png", ext: "png" };
    if (base64.startsWith("/9j/")) return { mime: "image/jpeg", ext: "jpg" };
    if (base64.startsWith("R0lGOD")) return { mime: "image/gif", ext: "gif" };
    if (base64.startsWith("UklGR")) return { mime: "image/webp", ext: "webp" };
    if (base64.startsWith("PHN2Zy") || base64.startsWith("PD94bW"))
      return { mime: "image/svg+xml", ext: "svg" };
    return { mime: "image/png", ext: "png" };
  };

  const handleDownloadSign = (base64, type) => {
    if (!base64) return;

    const { mime, ext } = getImageMeta(base64);

    const baseName = (editUserData.sign_name || editUserData.name || "user")
      .toString()
      .trim()
      .replace(/[\\/:*?"<>|]/g, "")
      .replace(/\s+/g, "_");

    const link = document.createElement("a");
    link.href = `data:${mime};base64,${base64}`;
    link.download = `${baseName}-${type}.${ext}`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const queryCellInfo = (args) => {
    args.cell?.classList.add("e-cell");
  };

  const dataBound = () => {
    if (gridRef.current) {
      gridRef.current.autoFitColumns([
        "Name",
        "Username",
        "Balance",
        "Email",
        "EmailVerified",
        "PhoneNumber",
        "PhoneNumberVerified",
        "CreatedAt",
        "Uuid",
      ]);
    }
  };

  const toolbarClick = (args) => {
    if (gridRef.current && args.item.id.includes("excelexport")) {
      const excelExportProperties = {
        fileName: "Paperless - Digitalisasi Untuk Negeri User List.xlsx",
      };
      gridRef.current.excelExport(excelExportProperties);
    }
  };

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const resetForm = () => {
    setEditUserData({
      uuid: null,
      username: null,
      password: null,
      country_id: null,
      name: null,
      birthdate: null,
      email: null,
      email_verified: null,
      phone_number: null,
      nik: null,
      no_npwp: null,
      username: null,
      sign_name: null,
      place_of_birth: null,
      gender: null,
      address: null,
      city_id: null,
      is_wna: null,
      is_markany_user: false,
      ktp_foto: null,
      markany_username: null,
      markany_password: null,
      markany_user_id: null,
      role_id: null,
      status: null,
      org_unit: null,
      work_unit: null,
      position: null,
      token: null,
      refresh_token: null,
      exp_token: null,
      email_pj: null,
      nama_pj: null,
    });
    setEditUserWarning({
      username: null,
      password: null,
      country_id: null,
      name: null,
      birthdate: null,
      place_of_birth: null,
      gender: null,
      email: null,
      email_verified: null,
      phone_number: null,
      nik: null,
      no_npwp: null,
      address: null,
      city_id: null,
      is_wna: null,
      sign_name: null,
      markany_username: null,
      markany_password: null,
      email_pj: null,
      nama_pj: null,
      role_id: null,
    });
  };

  const handleFileUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      if (file.type !== "image/png") {
        toast.error("Error: File harus berformat PNG!");
        return;
      }
      const maxSize = 1 * 1024 * 1024;
      if (file.size > maxSize) {
        toast.error("Error: Ukuran file maksimal 1 MB!");
        return;
      }

      const reader = new FileReader();
      reader.onload = (event) => {
        setEditUserData((prev) => ({
          ...prev,
          ktp_foto: event.target.result.split(",")[1],
        }));
      };
      reader.readAsDataURL(file);
    }
  };

  const userPersonalFormFields = () => (
    <>
      <div className="flex flex-col gap-2">
        <h4 className="font-medium">Country</h4>
        <DropDownListComponent
          allowFiltering
          dataSource={countries}
          fields={{ text: "text", value: "value" }}
          placeholder="Select country"
          value={editUserData.country_id}
          change={(e) =>
            setEditUserData((prev) => ({ ...prev, country_id: e.value }))
          }
          enabled={!isDetailMode}
          cssClass={editUserWarning.country_id ? "e-error" : ""}
        />
        {editUserWarning.country_id && (
          <p className="text-xs text-red-500">{editUserWarning.country_id}</p>
        )}
      </div>

      <div className="flex flex-col gap-2 col-span-2">
        <h4 className="font-medium">KTP Photo</h4>
        {!isDetailMode && (
          <React.Fragment>
            <input
              type="file"
              accept="image/png"
              onChange={handleFileUpload}
              className="w-full p-2 text-sm rounded-[4px] border border-slate-500 focus:outline-2 focus:outline-sky-500"
            />
            <span className="text-xs text-slate-500">
              *Format file: <strong>PNG</strong>, ukuran maksimal{" "}
              <strong>1 MB</strong>
            </span>
          </React.Fragment>
        )}
        {editUserData.ktp_foto && (
          <img
            src={`data:image/*;base64,${editUserData.ktp_foto}`}
            alt="KTP"
            className="w-48 h-32 object-cover border rounded"
          />
        )}
      </div>

      <div className="flex flex-col gap-2">
        <h4 className="font-medium">NIK</h4>
        <input
          type="number"
          placeholder="Input NIK..."
          className={
            "w-full p-2 text-sm rounded-[4px] border focus:outline-2 " +
            (!editUserWarning.nik
              ? "border-slate-500 focus:outline-sky-500"
              : "border-red-500 focus:outline-red-500")
          }
          value={editUserData.nik || ""}
          disabled={isDetailMode}
          onChange={(e) =>
            setEditUserData((prev) => ({ ...prev, nik: e.target.value }))
          }
        />
      </div>

      <div className="flex flex-col gap-2">
        <h4 className="font-medium">NPWP</h4>
        <input
          type="number"
          placeholder="Input NPWP..."
          className={
            "w-full p-2 text-sm rounded-[4px] border focus:outline-2 " +
            (!editUserWarning.no_npwp
              ? "border-slate-500 focus:outline-sky-500"
              : "border-red-500 focus:outline-red-500")
          }
          value={editUserData.no_npwp || ""}
          disabled={isDetailMode}
          onChange={(e) =>
            setEditUserData((prev) => ({ ...prev, no_npwp: e.target.value }))
          }
        />
      </div>

      <div className="flex flex-col gap-2">
        <h4 className="font-medium">Name</h4>
        <input
          type="text"
          placeholder="Input name..."
          className={
            "w-full p-2 text-sm rounded-[4px] border focus:outline-2 " +
            (!editUserWarning.name
              ? "border-slate-500 focus:outline-sky-500"
              : "border-red-500 focus:outline-red-500")
          }
          value={editUserData.name || ""}
          disabled={isDetailMode}
          onChange={(e) => {
            setEditUserData((prev) => ({ ...prev, name: e.target.value }));
            if (e.target.value.length < 1) {
              setEditUserWarning((prev) => ({
                ...prev,
                name: "Name is required",
              }));
            } else {
              setEditUserWarning((prev) => ({ ...prev, name: null }));
            }
          }}
        />
        {editUserWarning.name && (
          <p className="text-xs text-red-500">{editUserWarning.name}</p>
        )}
      </div>

      <div className="flex flex-col gap-2">
        <h4 className="font-medium">Email</h4>
        <input
          type="email"
          placeholder="Input email..."
          className={
            "w-full p-2 text-sm rounded-[4px] border focus:outline-2 " +
            (!editUserWarning.email
              ? "border-slate-500 focus:outline-sky-500"
              : "border-red-500 focus:outline-red-500")
          }
          value={editUserData.email || ""}
          disabled={isDetailMode}
          onChange={(e) => {
            setEditUserData((prev) => ({ ...prev, email: e.target.value }));
            if (e.target.value.length < 1) {
              setEditUserWarning((prev) => ({
                ...prev,
                email: "Email is required",
              }));
            } else if (!validateEmail(e.target.value)) {
              setEditUserWarning((prev) => ({
                ...prev,
                email: "Invalid email format",
              }));
            } else {
              setEditUserWarning((prev) => ({ ...prev, email: null }));
            }
          }}
        />
        {editUserWarning.email && (
          <p className="text-xs text-red-500">{editUserWarning.email}</p>
        )}
      </div>

      <div className="flex flex-col gap-2">
        <h4 className="font-medium">Email Verified</h4>
        <DropDownListComponent
          dataSource={emailVerifiedOptions}
          fields={{ text: "text", value: "value" }}
          placeholder="Select email verified status"
          value={editUserData.email_verified}
          change={(e) => {
            setEditUserData((prev) => ({ ...prev, email_verified: e.value }));
            setEditUserWarning((prev) => ({ ...prev, email_verified: null }));
          }}
          enabled={!isDetailMode}
          cssClass={editUserWarning.email_verified ? "e-error" : ""}
        />
        {editUserWarning.email_verified && (
          <p className="text-xs text-red-500">
            {editUserWarning.email_verified}
          </p>
        )}
      </div>

      <div className="flex flex-col gap-2">
        <h4 className="font-medium">Birth Date</h4>
        <DatePickerComponent
          placeholder="Select birth date"
          value={editUserData.birthdate}
          change={(e) =>
            setEditUserData((prev) => ({ ...prev, birthdate: e.value }))
          }
          enabled={!isDetailMode}
          cssClass={editUserWarning.birthdate ? "e-error" : ""}
        />
        {editUserWarning.birthdate && (
          <p className="text-xs text-red-500">{editUserWarning.birthdate}</p>
        )}
      </div>

      <div className="flex flex-col gap-2">
        <h4 className="font-medium">Place of Birth</h4>
        <input
          type="text"
          placeholder="Input place of birth..."
          className="w-full p-2 text-sm rounded-[4px] border border-slate-500 focus:outline-2 focus:outline-sky-500"
          value={editUserData.place_of_birth || ""}
          disabled={isDetailMode}
          onChange={(e) =>
            setEditUserData((prev) => ({
              ...prev,
              place_of_birth: e.target.value,
            }))
          }
        />
      </div>

      <div className="flex flex-col gap-2">
        <h4 className="font-medium">Gender</h4>
        <DropDownListComponent
          dataSource={genderOptions}
          fields={{ text: "text", value: "value" }}
          placeholder="Select gender"
          value={editUserData.gender}
          change={(e) =>
            setEditUserData((prev) => ({ ...prev, gender: e.value }))
          }
          enabled={!isDetailMode}
        />
      </div>

      <div className="flex flex-col gap-2">
        <h4 className="font-medium">Phone Number</h4>
        <input
          type="number"
          placeholder="Input phone number..."
          className={
            "w-full p-2 text-sm rounded-[4px] border focus:outline-2 " +
            (!editUserWarning.phone_number
              ? "border-slate-500 focus:outline-sky-500"
              : "border-red-500 focus:outline-red-500")
          }
          value={editUserData.phone_number || ""}
          disabled={isDetailMode}
          onChange={(e) =>
            setEditUserData((prev) => ({
              ...prev,
              phone_number: e.target.value,
            }))
          }
        />
      </div>

      <div className="flex flex-col gap-2 col-span-2">
        <h4 className="font-medium">Address</h4>
        <textarea
          placeholder="Input address..."
          rows={3}
          className="w-full p-2 text-sm rounded-[4px] border border-slate-500 focus:outline-2 focus:outline-sky-500"
          value={editUserData.address || ""}
          disabled={isDetailMode}
          onChange={(e) =>
            setEditUserData((prev) => ({
              ...prev,
              address: e.target.value,
            }))
          }
        />
      </div>

      <div className="flex flex-col gap-2">
        <h4 className="font-medium">City</h4>
        <DropDownListComponent
          allowFiltering
          filtering={(onCityFiltering = onCityFiltering.bind(this))}
          dataSource={cities}
          fields={{ text: "text", value: "value" }}
          placeholder="Select city"
          value={editUserData.city_id}
          change={(e) =>
            setEditUserData((prev) => ({ ...prev, city_id: e.value }))
          }
          enabled={!isDetailMode}
        />
      </div>

      <div className="flex flex-col gap-2">
        <h4 className="font-medium">Is WNA</h4>
        <DropDownListComponent
          dataSource={isWnaOptions}
          fields={{ text: "text", value: "value" }}
          placeholder="Select WNA status"
          value={editUserData.is_wna}
          change={(e) =>
            setEditUserData((prev) => ({ ...prev, is_wna: e.value }))
          }
          enabled={!isDetailMode}
        />
      </div>

      <div className="flex flex-col gap-2">
        <h4 className="font-medium">Sign Name</h4>
        <input
          type="text"
          placeholder="Input sign name..."
          className="w-full p-2 text-sm rounded-[4px] border border-slate-500 focus:outline-2 focus:outline-sky-500"
          value={editUserData.sign_name || ""}
          disabled={isDetailMode}
          onChange={(e) =>
            setEditUserData((prev) => ({
              ...prev,
              sign_name: e.target.value,
            }))
          }
        />
      </div>
    </>
  );

  const userCompanyFormFiels = () => (
    <>
      <div className="flex flex-col gap-2">
        <h4 className="font-medium">Country</h4>
        <DropDownListComponent
          allowFiltering
          dataSource={countries}
          fields={{ text: "text", value: "value" }}
          placeholder="Select country"
          value={editUserData.country_id}
          change={(e) =>
            setEditUserData((prev) => ({ ...prev, country_id: e.value }))
          }
          enabled={!isDetailMode}
          cssClass={editUserWarning.country_id ? "e-error" : ""}
        />
        {editUserWarning.country_id && (
          <p className="text-xs text-red-500">{editUserWarning.country_id}</p>
        )}
      </div>

      <div className="flex flex-col gap-2">
        <h4 className="font-medium">Name Perusahaan</h4>
        <input
          type="text"
          placeholder="Input name..."
          className={
            "w-full p-2 text-sm rounded-[4px] border focus:outline-2 " +
            (!editUserWarning.name
              ? "border-slate-500 focus:outline-sky-500"
              : "border-red-500 focus:outline-red-500")
          }
          value={editUserData.name || ""}
          disabled={isDetailMode}
          onChange={(e) => {
            setEditUserData((prev) => ({ ...prev, name: e.target.value }));
            if (e.target.value.length < 1) {
              setEditUserWarning((prev) => ({
                ...prev,
                name: "Name is required",
              }));
            } else {
              setEditUserWarning((prev) => ({ ...prev, name: null }));
            }
          }}
        />
        {editUserWarning.name && (
          <p className="text-xs text-red-500">{editUserWarning.name}</p>
        )}
      </div>

      <div className="flex flex-col gap-2">
        <h4 className="font-medium">Email Perusahaan</h4>
        <input
          type="email"
          placeholder="Input email..."
          className={
            "w-full p-2 text-sm rounded-[4px] border focus:outline-2 " +
            (!editUserWarning.email
              ? "border-slate-500 focus:outline-sky-500"
              : "border-red-500 focus:outline-red-500")
          }
          value={editUserData.email || ""}
          disabled={isDetailMode}
          onChange={(e) => {
            setEditUserData((prev) => ({ ...prev, email: e.target.value }));
            if (e.target.value.length < 1) {
              setEditUserWarning((prev) => ({
                ...prev,
                email: "Email is required",
              }));
            } else if (!validateEmail(e.target.value)) {
              setEditUserWarning((prev) => ({
                ...prev,
                email: "Invalid email format",
              }));
            } else {
              setEditUserWarning((prev) => ({ ...prev, email: null }));
            }
          }}
        />
        {editUserWarning.email && (
          <p className="text-xs text-red-500">{editUserWarning.email}</p>
        )}
      </div>

      {/* TAMBAHAN BARU: Email Verified */}
      <div className="flex flex-col gap-2">
        <h4 className="font-medium">Email Verified</h4>
        <DropDownListComponent
          dataSource={emailVerifiedOptions}
          fields={{ text: "text", value: "value" }}
          placeholder="Select email verified status"
          value={editUserData.email_verified}
          change={(e) => {
            setEditUserData((prev) => ({ ...prev, email_verified: e.value }));
            setEditUserWarning((prev) => ({ ...prev, email_verified: null }));
          }}
          enabled={!isDetailMode}
          cssClass={editUserWarning.email_verified ? "e-error" : ""}
        />
        {editUserWarning.email_verified && (
          <p className="text-xs text-red-500">
            {editUserWarning.email_verified}
          </p>
        )}
      </div>

      <div className="flex flex-col gap-2 col-span-2">
        <h4 className="font-medium">Address</h4>
        <textarea
          placeholder="Input address..."
          rows={3}
          className="w-full p-2 text-sm rounded-[4px] border border-slate-500 focus:outline-2 focus:outline-sky-500"
          value={editUserData.address || ""}
          disabled={isDetailMode}
          onChange={(e) =>
            setEditUserData((prev) => ({
              ...prev,
              address: e.target.value,
            }))
          }
        />
      </div>

      <div className="flex flex-col gap-2">
        <h4 className="font-medium">City</h4>
        <DropDownListComponent
          allowFiltering
          filtering={(onCityFiltering = onCityFiltering.bind(this))}
          dataSource={cities}
          fields={{ text: "text", value: "value" }}
          placeholder="Select city"
          value={editUserData.city_id}
          change={(e) =>
            setEditUserData((prev) => ({ ...prev, city_id: e.value }))
          }
          enabled={!isDetailMode}
        />
      </div>

      <div className="flex flex-col gap-2">
        <h4 className="font-medium">Is WNA</h4>
        <DropDownListComponent
          dataSource={isWnaOptions}
          fields={{ text: "text", value: "value" }}
          placeholder="Select WNA status"
          value={editUserData.is_wna}
          change={(e) =>
            setEditUserData((prev) => ({ ...prev, is_wna: e.value }))
          }
          enabled={!isDetailMode}
        />
      </div>

      <div className="flex flex-col gap-2">
        <h4 className="font-medium">NIK</h4>
        <input
          type="number"
          placeholder="Input NIK..."
          className={
            "w-full p-2 text-sm rounded-[4px] border focus:outline-2 " +
            (!editUserWarning.nik
              ? "border-slate-500 focus:outline-sky-500"
              : "border-red-500 focus:outline-red-500")
          }
          value={editUserData.nik || ""}
          disabled={isDetailMode}
          onChange={(e) =>
            setEditUserData((prev) => ({ ...prev, nik: e.target.value }))
          }
        />
      </div>

      <div className="flex flex-col gap-2">
        <h4 className="font-medium">NPWP</h4>
        <input
          type="number"
          placeholder="Input NPWP..."
          className={
            "w-full p-2 text-sm rounded-[4px] border focus:outline-2 " +
            (!editUserWarning.no_npwp
              ? "border-slate-500 focus:outline-sky-500"
              : "border-red-500 focus:outline-red-500")
          }
          value={editUserData.no_npwp || ""}
          disabled={isDetailMode}
          onChange={(e) =>
            setEditUserData((prev) => ({ ...prev, no_npwp: e.target.value }))
          }
        />
      </div>

      <div className="flex flex-col gap-2">
        <h4 className="font-medium">Nama Penanggung Jawab</h4>
        <input
          type="text"
          placeholder="Input name..."
          className={
            "w-full p-2 text-sm rounded-[4px] border focus:outline-2 " +
            (!editUserWarning.nama_pj
              ? "border-slate-500 focus:outline-sky-500"
              : "border-red-500 focus:outline-red-500")
          }
          value={editUserData.nama_pj || ""}
          disabled={isDetailMode}
          onChange={(e) => {
            setEditUserData((prev) => ({ ...prev, nama_pj: e.target.value }));
            if (e.target.value.length < 1) {
              setEditUserWarning((prev) => ({
                ...prev,
                nama_pj: "Nama Penanggung Jawab is required",
              }));
            } else {
              setEditUserWarning((prev) => ({ ...prev, nama_pj: null }));
            }
          }}
        />
        {editUserWarning.nama_pj && (
          <p className="text-xs text-red-500">{editUserWarning.nama_pj}</p>
        )}
      </div>

      <div className="flex flex-col gap-2">
        <h4 className="font-medium">Email Penanggung Jawab</h4>
        <input
          type="email"
          placeholder="Input email..."
          className={
            "w-full p-2 text-sm rounded-[4px] border focus:outline-2 " +
            (!editUserWarning.email_pj
              ? "border-slate-500 focus:outline-sky-500"
              : "border-red-500 focus:outline-red-500")
          }
          value={editUserData.email_pj || ""}
          disabled={isDetailMode}
          onChange={(e) => {
            setEditUserData((prev) => ({ ...prev, email_pj: e.target.value }));
            if (e.target.value.length < 1) {
              setEditUserWarning((prev) => ({
                ...prev,
                email_pj: "Email is required",
              }));
            } else if (!validateEmail(e.target.value)) {
              setEditUserWarning((prev) => ({
                ...prev,
                email_pj: "Invalid email format",
              }));
            } else {
              setEditUserWarning((prev) => ({ ...prev, email_pj: null }));
            }
          }}
        />
        {editUserWarning.email_pj && (
          <p className="text-xs text-red-500">{editUserWarning.email_pj}</p>
        )}
      </div>

      <div className="flex flex-col gap-2">
        <h4 className="font-medium">Birth Date</h4>
        <DatePickerComponent
          placeholder="Select birth date"
          value={editUserData.birthdate}
          change={(e) =>
            setEditUserData((prev) => ({ ...prev, birthdate: e.value }))
          }
          enabled={!isDetailMode}
          cssClass={editUserWarning.birthdate ? "e-error" : ""}
        />
        {editUserWarning.birthdate && (
          <p className="text-xs text-red-500">{editUserWarning.birthdate}</p>
        )}
      </div>
      <div className="flex flex-col gap-2">
        <h4 className="font-medium">Place of Birth</h4>
        <input
          type="text"
          placeholder="Input place of birth..."
          className="w-full p-2 text-sm rounded-[4px] border border-slate-500 focus:outline-2 focus:outline-sky-500"
          value={editUserData.place_of_birth || ""}
          disabled={isDetailMode}
          onChange={(e) =>
            setEditUserData((prev) => ({
              ...prev,
              place_of_birth: e.target.value,
            }))
          }
        />
      </div>

      <div className="flex flex-col gap-2">
        <h4 className="font-medium">Gender</h4>
        <DropDownListComponent
          dataSource={genderOptions}
          fields={{ text: "text", value: "value" }}
          placeholder="Select gender"
          value={editUserData.gender}
          change={(e) =>
            setEditUserData((prev) => ({ ...prev, gender: e.value }))
          }
          enabled={!isDetailMode}
        />
      </div>

      <div className="flex flex-col gap-2">
        <h4 className="font-medium">Phone Number</h4>
        <input
          type="number"
          placeholder="Input phone number..."
          className={
            "w-full p-2 text-sm rounded-[4px] border focus:outline-2 " +
            (!editUserWarning.phone_number
              ? "border-slate-500 focus:outline-sky-500"
              : "border-red-500 focus:outline-red-500")
          }
          value={editUserData.phone_number || ""}
          disabled={isDetailMode}
          onChange={(e) =>
            setEditUserData((prev) => ({
              ...prev,
              phone_number: e.target.value,
            }))
          }
        />
      </div>
    </>
  );

  const addUserCompanyFormFields = () => (
    <>
      <div className="flex flex-col gap-2">
        <h4 className="font-medium">Username</h4>
        <input
          type="text"
          placeholder="Input username..."
          className="w-full p-2 text-sm rounded-[4px] border border-slate-500 focus:outline-2 focus:outline-sky-500"
          value={editUserData.username || ""}
          onChange={(e) =>
            setEditUserData((prev) => ({
              ...prev,
              username: e.target.value,
            }))
          }
        />
        {editUserWarning.username && (
          <p className="text-xs text-red-500">{editUserWarning.username}</p>
        )}
      </div>

      <div className="flex flex-col gap-2">
        <h4 className="font-medium">Password</h4>
        <InputPassword
          value={editUserData.password || ""}
          onChange={(e) =>
            setEditUserData((prev) => ({
              ...prev,
              password: e.target.value,
            }))
          }
        />
        {editUserWarning.password && (
          <p className="text-xs text-red-500">{editUserWarning.password}</p>
        )}
      </div>
    </>
  );

  const renderFormFields = (isEdit = false) => (
    <div className="flex flex-col gap-4 w-full">
      {/* Users Table Fields */}
      <div className="border-b pb-4">
        <h3 className="text-lg font-semibold mb-4">User Information</h3>

        <div className="grid grid-cols-2 gap-4">
          {isEdit && (
            <div className="flex flex-col gap-2">
              <h4 className="font-medium">Role</h4>
              <DropDownListComponent
                dataSource={roles}
                fields={{ text: "text", value: "value" }}
                placeholder="Select Role"
                value={editUserData.role_id}
                change={(e) => {
                  if (e.value) {
                    const role = roles.find((role) => role.value == e.value);
                    setRoleSelected(role.key);
                    setEditUserData((prev) => ({ ...prev, role_id: e.value }));
                    setEditUserWarning((prev) => ({ ...prev, role_id: null }));
                  } else {
                    setEditUserWarning((prev) => ({
                      ...prev,
                      role_id: "Role can't be empty",
                    }));
                  }
                }}
                enabled={!isDetailMode}
                cssClass={editUserWarning.role_id ? "e-error" : ""}
              />
              {editUserWarning.role_id && (
                <p className="text-xs text-red-500">
                  {editUserWarning.role_id}
                </p>
              )}
            </div>
          )}

          {toggleAdd && addUserCompanyFormFields()}

          {!isEdit && (
            <div className="flex flex-col gap-2">
              <h4 className="font-medium">Role</h4>
              <input
                type="text"
                placeholder="Input name..."
                className={
                  "w-full p-2 text-sm rounded-[4px] border focus:outline-2 " +
                  (!editUserWarning.role_id
                    ? "border-slate-500 focus:outline-sky-500"
                    : "border-red-500 focus:outline-red-500")
                }
                value="Perusahaan"
                disabled={true}
              />
            </div>
          )}
          {roleSelected == PERSONEL && userPersonalFormFields()}
          {roleSelected == COMPANY && userCompanyFormFiels()}
        </div>

        <div className="grid grid-cols-2 gap-4">
          <div className="grid grid-cols-2 gap-4">
            {editUserData.ttd_signature && (
              <div className="flex flex-col gap-2 mt-4">
                <h4 className="font-medium">TTD Signature</h4>
                <div className="relative w-48 h-32">
                  <img
                    src={`data:image/*;base64,${editUserData.ttd_signature}`}
                    alt="TTD Signature"
                    className="w-full h-full object-cover border rounded"
                  />
                  <button
                    type="button"
                    title="Download Signature"
                    onClick={() =>
                      handleDownloadSign(
                        editUserData.ttd_signature,
                        "signature",
                      )
                    }
                    className="absolute top-1 right-1 p-1.5 rounded-md bg-black/60 hover:bg-black/80 text-white transition"
                  >
                    <FaDownload className="w-3.5 h-3.5" />
                  </button>
                </div>
              </div>
            )}

            {editUserData.ttd_paraf && (
              <div className="flex flex-col gap-2 mt-4">
                <h4 className="font-medium">TTD Paraf</h4>
                <div className="relative w-48 h-32">
                  <img
                    src={`data:image/*;base64,${editUserData.ttd_paraf}`}
                    alt="TTD Paraf"
                    className="w-full h-full object-cover border rounded"
                  />
                  <button
                    type="button"
                    title="Download Paraf"
                    onClick={() =>
                      handleDownloadSign(editUserData.ttd_paraf, "paraf")
                    }
                    className="absolute top-1 right-1 p-1.5 rounded-md bg-black/60 hover:bg-black/80 text-white transition"
                  >
                    <FaDownload className="w-3.5 h-3.5" />
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>

        {editUserData.ekyc && (
          <div className="flex flex-col gap-2 mt-4">
            <h4 className="font-medium">EKYC Video</h4>
            <video
              src={`data:video/webm;base64,${editUserData.ekyc}`}
              controls
              className="w-full aspect-video object-cover bg-black rounded-lg"
            >
              Browser Anda tidak mendukung pemutaran video.
            </video>
          </div>
        )}
      </div>

      {/* User Markany Table Fields */}
      <div>
        <h3 className="text-lg font-semibold mb-4">Markany Information</h3>

        <div className="flex flex-col gap-2 col-span-2">
          <h4 className="font-medium">Is Markany User</h4>
          <DropDownListComponent
            dataSource={emailVerifiedOptions}
            fields={{ text: "text", value: "value" }}
            placeholder="Select markany user status"
            value={editUserData.is_markany_user}
            change={(e) => {
              setEditUserData((prev) => ({
                ...prev,
                is_markany_user: e.value,
              }));
              setEditUserWarning((prev) => ({
                ...prev,
                is_markany_user: null,
              }));
            }}
            enabled={!isDetailMode}
            cssClass={editUserWarning.is_markany_user ? "e-error" : ""}
          />
          {editUserWarning.is_markany_user && (
            <p className="text-xs text-red-500">
              {editUserWarning.is_markany_user}
            </p>
          )}
        </div>

        <div className="grid grid-cols-2 gap-4">
          <div className="flex flex-col gap-2">
            <h4 className="font-medium">Markany Username</h4>
            <input
              type="text"
              placeholder="Input markany username..."
              className="w-full p-2 text-sm rounded-[4px] border border-slate-500 focus:outline-2 focus:outline-sky-500"
              value={editUserData.markany_username || ""}
              disabled={isDetailMode}
              onChange={(e) =>
                setEditUserData((prev) => ({
                  ...prev,
                  markany_username: e.target.value,
                }))
              }
            />
          </div>

          <div className="flex flex-col gap-2">
            <h4 className="font-medium">Markany Password</h4>
            <InputPassword
              value={editUserData.markany_password || ""}
              disabled={isDetailMode}
              onChange={(e) =>
                setEditUserData((prev) => ({
                  ...prev,
                  markany_password: e.target.value,
                }))
              }
            />
          </div>

          <div className="flex flex-col gap-2">
            <h4 className="font-medium">Markany Email</h4>
            <input
              type="email"
              placeholder="Input markany email..."
              className={
                "w-full p-2 text-sm rounded-[4px] border focus:outline-2 " +
                (!editUserWarning.markany_email
                  ? "border-slate-500 focus:outline-sky-500"
                  : "border-red-500 focus:outline-red-500")
              }
              value={editUserData.markany_email || ""}
              disabled={isDetailMode}
              onChange={(e) => {
                setEditUserData((prev) => ({
                  ...prev,
                  markany_email: e.target.value,
                }));
                if (e.target.value.length < 1) {
                  setEditUserWarning((prev) => ({
                    ...prev,
                    markany_email: "Email is required",
                  }));
                } else if (!validateEmail(e.target.value)) {
                  setEditUserWarning((prev) => ({
                    ...prev,
                    markany_email: "Invalid email format",
                  }));
                } else {
                  setEditUserWarning((prev) => ({
                    ...prev,
                    markany_email: null,
                  }));
                }
              }}
            />
            {editUserWarning.markany_email && (
              <p className="text-xs text-red-500">
                {editUserWarning.markany_email}
              </p>
            )}
          </div>

          <div className="flex flex-col gap-2">
            <h4 className="font-medium">Markany User ID</h4>
            <input
              type="text"
              className="w-full p-2 text-sm rounded-[4px] border border-gray-300 bg-gray-100"
              value={editUserData.markany_user_id || ""}
            />
          </div>

          <div className="flex flex-col gap-2">
            <h4 className="font-medium">Role ID</h4>
            <input
              type="text"
              className="w-full p-2 text-sm rounded-[4px] border border-gray-300 bg-gray-100"
              value={editUserData.markany_role_id || ""}
              readOnly
            />
          </div>

          <div className="flex flex-col gap-2">
            <h4 className="font-medium">Status</h4>
            <input
              type="text"
              className="w-full p-2 text-sm rounded-[4px] border border-gray-300 bg-gray-100"
              value={editUserData.status || ""}
              readOnly
            />
          </div>

          <div className="flex flex-col gap-2">
            <h4 className="font-medium">Org Unit</h4>
            <input
              type="text"
              placeholder="Input markany org unit..."
              className="w-full p-2 text-sm rounded-[4px] border border-slate-500 focus:outline-2 focus:outline-sky-500"
              value={editUserData.org_unit || ""}
              disabled={isDetailMode}
              onChange={(e) =>
                setEditUserData((prev) => ({
                  ...prev,
                  org_unit: e.target.value,
                }))
              }
            />
          </div>

          <div className="flex flex-col gap-2">
            <h4 className="font-medium">Work Unit</h4>
            <input
              type="text"
              placeholder="Input markany work unit..."
              className="w-full p-2 text-sm rounded-[4px] border border-slate-500 focus:outline-2 focus:outline-sky-500"
              value={editUserData.work_unit || ""}
              disabled={isDetailMode}
              onChange={(e) =>
                setEditUserData((prev) => ({
                  ...prev,
                  work_unit: e.target.value,
                }))
              }
            />
          </div>

          <div className="flex flex-col gap-2">
            <h4 className="font-medium">Position</h4>
            <input
              type="text"
              placeholder="Input markany position..."
              className="w-full p-2 text-sm rounded-[4px] border border-slate-500 focus:outline-2 focus:outline-sky-500"
              value={editUserData.position || ""}
              disabled={isDetailMode}
              onChange={(e) =>
                setEditUserData((prev) => ({
                  ...prev,
                  position: e.target.value,
                }))
              }
            />
          </div>

          <div className="flex flex-col gap-2 col-span-2">
            <h4 className="font-medium">Token</h4>
            <textarea
              className="w-full p-2 text-sm rounded-[4px] border border-gray-300 bg-gray-100"
              value={editUserData.token || ""}
              rows={2}
              readOnly
            />
          </div>

          <div className="flex flex-col gap-2 col-span-2">
            <h4 className="font-medium">Refresh Token</h4>
            <textarea
              className="w-full p-2 text-sm rounded-[4px] border border-gray-300 bg-gray-100"
              value={editUserData.refresh_token || ""}
              rows={2}
              readOnly
            />
          </div>

          <div className="flex flex-col gap-2">
            <h4 className="font-medium">Token Expiry</h4>
            <input
              type="text"
              className="w-full p-2 text-sm rounded-[4px] border border-gray-300 bg-gray-100"
              value={editUserData.exp_token || ""}
              readOnly
            />
          </div>
        </div>
      </div>
    </div>
  );

  return pageLoading ? (
    <PageLoading />
  ) : (
    <div className="m-2 md:m-10 mt-24 px-2 py-10 md:p-10 bg-white rounded-3xl">
      <div className="flex justify-between">
        <Header title="User List Data" />
        <div>
          <button
            style={{ backgroundColor: currentColor }}
            className="text-white py-2 px-4 rounded-md text-sm flex items-center gap-2 justify-center flex-nowrap"
            onClick={handleAddUser}
          >
            <FaPlus className="w-3 h-3" />
            <div className="text-nowrap">Add User</div>
          </button>
        </div>
      </div>
      <div className="overflow-x-auto">
        <div className="cursor-pointer">
          <GridComponent
            dataSource={userList}
            allowPaging
            allowSorting
            allowTextWrap={true}
            pageSettings={{
              pageCount: 5,
              pageSizes: ["All", "10", "25", "50"],
            }}
            textWrapSettings={{ wrapMode: "Content" }}
            toolbar={["Search", "ExcelExport"]}
            queryCellInfo={queryCellInfo}
            allowExcelExport={true}
            toolbarClick={toolbarClick}
            dataBound={dataBound}
            ref={gridRef}
          >
            <ColumnsDirective>
              <ColumnDirective
                field="No"
                headerText="No"
                textAlign="Center"
                width={50}
                type="Number"
              />
              <ColumnDirective
                field="Uuid"
                headerText="Action"
                textAlign="Left"
                isPrimaryKey={true}
                template={actionTemplate}
                minWidth={300}
              />
              <ColumnDirective field="Name" headerText="Name" minWidth={150} />
              <ColumnDirective
                field="Username"
                headerText="Username"
                minWidth={150}
              />
              <ColumnDirective
                field="Balance"
                headerText="Balance"
                textAlign="Center"
                minWidth={150}
              />
              <ColumnDirective
                field="Email"
                headerText="Email"
                textAlign="Center"
                minWidth={150}
              />
              <ColumnDirective
                field="EmailVerified"
                headerText="Email Verified"
                textAlign="Center"
                width={120}
                template={(props) => (
                  <span
                    className={`px-2 py-1 rounded-full text-xs font-medium ${
                      props.EmailVerified
                        ? "bg-green-100 text-green-800"
                        : "bg-red-100 text-red-800"
                    }`}
                  >
                    {props.EmailVerified ? "Verified" : "Unverified"}
                  </span>
                )}
              />
              <ColumnDirective
                field="PhoneNumber"
                headerText="Phone Number"
                minWidth={150}
              />
              <ColumnDirective
                field="PhoneNumberVerified"
                headerText="Phone Number Verified"
                textAlign="Center"
                minWidth={100}
              />
              <ColumnDirective
                field="CreatedAt"
                headerText="Created At"
                minWidth={150}
              />
            </ColumnsDirective>
            <Inject
              services={[Search, Toolbar, Page, Sort, Resize, ExcelExport]}
            />
          </GridComponent>
        </div>
      </div>

      {/* Edit Modal */}
      {toggleEdit && (
        <div className="overflow-auto absolute z-[99] top-0 left-0 flex justify-center w-full min-h-screen h-full overflow-y-auto py-10 px-4 bg-slate-800/50">
          <div className="bg-white flex flex-col gap-2 w-full max-w-4xl h-fit rounded-xl p-8">
            <div className="flex items-center justify-between">
              <h1 className="text-xl font-medium">Edit User</h1>
              <div
                className="cursor-pointer p-2"
                onClick={() => {
                  setToggleEdit(false);
                  resetForm();
                }}
              >
                <FaXmark className="w-4 h-4" />
              </div>
            </div>
            <hr />

            {renderFormFields(true)}

            <div className="flex justify-end items-center gap-2 mt-6">
              <button
                disabled={editUserDisabled}
                className={
                  "text-gray-600 w-36 py-2 px-4 rounded-md text-sm border border-gray-300" +
                  (editUserDisabled
                    ? "cursor-not-allowed opacity-50"
                    : "cursor-pointer")
                }
                onClick={() => {
                  handleMarkanySignIn(editUserData);
                }}
              >
                {!editLoading ? "Sign In Markany" : "Loading..."}
              </button>
              <button
                className="text-gray-600 w-36 py-2 px-4 rounded-md text-sm border border-gray-300"
                onClick={() => {
                  setToggleEdit(false);
                  resetForm();
                }}
              >
                Cancel
              </button>
              <button
                disabled={editUserDisabled}
                style={{ backgroundColor: currentColor }}
                className={
                  "text-white w-36 py-2 px-4 rounded-md text-sm " +
                  (editUserDisabled
                    ? "cursor-not-allowed opacity-50"
                    : "cursor-pointer")
                }
                onClick={() => handleSubmit(roleSelected, true)}
              >
                {!editLoading ? "Update User" : "Loading..."}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Add Modal */}
      {toggleAdd && (
        <div className="overflow-auto absolute z-[99] top-0 left-0 flex justify-center w-full min-h-screen h-full overflow-y-auto py-10 px-4 bg-slate-800/50">
          <div className="bg-white flex flex-col gap-2 w-full max-w-4xl h-fit rounded-xl p-8">
            <div className="flex items-center justify-between">
              <h1 className="text-xl font-medium">Tambah User Perusahaan</h1>
              <div
                className="cursor-pointer p-2"
                onClick={() => {
                  setToggleAdd(false);
                  resetForm();
                }}
              >
                <FaXmark className="w-4 h-4" />
              </div>
            </div>
            <hr />

            {renderFormFields(false)}

            <div className="flex justify-end items-center gap-2 mt-6">
              <button
                disabled={editUserDisabled}
                className={
                  "text-gray-600 w-36 py-2 px-4 rounded-md text-sm border border-gray-300" +
                  (editUserDisabled
                    ? "cursor-not-allowed opacity-50"
                    : "cursor-pointer")
                }
                onClick={() => {
                  handleMarkanySignIn(editUserData);
                }}
              >
                {!editLoading ? "Sign In Markany" : "Loading..."}
              </button>
              <button
                className="text-gray-600 w-36 py-2 px-4 rounded-md text-sm border border-gray-300"
                onClick={() => {
                  setToggleAdd(false);
                  resetForm();
                }}
              >
                Cancel
              </button>
              <button
                disabled={editUserDisabled}
                style={{ backgroundColor: currentColor }}
                className={
                  "text-white w-36 py-2 px-4 rounded-md text-sm " +
                  (editUserDisabled
                    ? "cursor-not-allowed opacity-50"
                    : "cursor-pointer")
                }
                onClick={() => handleSubmit(roleSelected, false)}
              >
                {!editLoading ? "Tambah User Perusahaan" : "Loading..."}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Detail Modal */}
      {toggleDetail && (
        <div className="overflow-auto absolute z-[99] top-0 left-0 flex justify-center w-full min-h-screen h-full overflow-y-auto py-10 px-4 bg-slate-800/50">
          <div className="bg-white flex flex-col gap-2 w-full max-w-4xl h-fit rounded-xl p-8">
            <div className="flex items-center justify-between">
              <h1 className="text-xl font-medium">User Details</h1>
              <div
                className="cursor-pointer p-2"
                onClick={() => {
                  setToggleDetail(false);
                  resetForm();
                }}
              >
                <FaXmark className="w-4 h-4" />
              </div>
            </div>
            <hr />

            {renderFormFields(true)}

            <div className="flex justify-end items-center mt-6">
              <button
                className="text-gray-600 w-36 py-2 px-4 rounded-md text-sm border border-gray-300"
                onClick={() => {
                  setToggleDetail(false);
                  resetForm();
                }}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default UserList;
